import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { DateRange, Decimal, Percentage } from '~/modules/common/components';
import { useProjectContext } from '~/modules/resourcing/common/contexts';
import useEstimatedRequestTotal from '../hooks/useEstimatedRequestTotal';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const ResourceRequestTooltipContent = ({
  canViewCostData,
  resourceRequest
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const { project } = useProjectContext();
  const {
    resourceRequestTotalHours,
    resourceRequestTotalCost
  } = useEstimatedRequestTotal({ resourceRequest, project });

  return (
    <div className={classes.title}>
      <DateRange
        classes={useMemo(
          () => ({ range: classes.title, date: classes.title }),
          [classes.title]
        )}
        start={resourceRequest.startDate}
        end={resourceRequest.endDate}
      />
      <br />
      <Percentage value={resourceRequest.load} fixedDecimalScale={false} />
      {resourceRequest.isAdjustedLoading && '*'}
      {'  '}-{'  '}
      <Decimal
        value={resourceRequestTotalHours}
        suffix={` ${intl.formatMessage({
          id: 'resourceRequestBlockLabel.hours'
        })}`}
      />
      {canViewCostData && resourceRequest.role && (
        <>
          {'  '}-{'  '}
          <Decimal
            value={resourceRequestTotalCost.amount}
            prefix={`${resourceRequestTotalCost.currencySymbol} `}
          />
        </>
      )}
      {resourceRequest.isAdjustedLoading && (
        <>
          <br />
          {intl.formatMessage({
            id: 'resourceLoadingField.adjustedLoading'
          })}
        </>
      )}
    </div>
  );
};

ResourceRequestTooltipContent.propTypes = {
  canViewCostData: PropTypes.bool,
  resourceRequest: PropTypes.object.isRequired
};

export default ResourceRequestTooltipContent;
